import React from 'react'
import injectSheet from 'react-jss'

const ListTile = (props) => {
  const {
    children,
    classes,
  } = props

  return (
    <ul className={`${classes.list}`}>
      {children}
    </ul>
  )
}

const styles = () => ({
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexWrap: 'wrap',
  },
})

export default injectSheet(styles)(ListTile)



// WEBPACK FOOTER //
// ./src/modules/core/components/listTile.jsx